var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 63,
    y: 62.9998,
    width: 62,
    height: 62,
    rx: 31,
    transform: "rotate(180 63 62.9998)",
    stroke: "#222222",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31 43.9998C31 44.552 31.4477 44.9998 32 44.9998C32.5523 44.9998 33 44.552 33 43.9998H31ZM32.7071 19.2926C32.3166 18.9021 31.6834 18.9021 31.2929 19.2926L24.9289 25.6566C24.5384 26.0471 24.5384 26.6803 24.9289 27.0708C25.3195 27.4613 25.9526 27.4613 26.3431 27.0708L32 21.414L37.6569 27.0708C38.0474 27.4613 38.6805 27.4613 39.0711 27.0708C39.4616 26.6803 39.4616 26.0471 39.0711 25.6566L32.7071 19.2926ZM33 43.9998L33 19.9998H31L31 43.9998H33Z",
    fill: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/ArrowUp.46be1841c70b3ac241d6e1cae0b1429b.svg";
export { ForwardRef as ReactComponent };